<template>
<ul class="sidebar-menu">
   <li class="header">Áreas</li>
   <router-link tag="li" class="pageLink" to="/">
      <a>
        <i class="fa fa-desktop"></i>
        <span class="page">Disponibilidade</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/oee">
      <a>
        <i class="fa fa-desktop"></i>
        <span class="page">OEE</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/maquinas">
      <a>
        <i class="fa ion-android-settings"></i>
        <span class="page">Máquinas</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/turnos">
      <a>
        <i class="fa ion-ios-alarm"></i>
        <span class="page">Turnos</span>
      </a>
    </router-link>
    <li class="treeview">
      <a href="#">
        <i class="fa ion-stats-bars"></i>
        <span>Relatórios</span>
        <span class="pull-right-container">
          <i class="fa fa-angle-left fa-fw pull-right"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/relatorios-gerais">
              <a>
                <span class="page"> Geral</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/relatorios-producao">
              <a>
                <span class="page"> Percentual de Operação</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/relatorios-producao-tag">
              <a>
                <span class="page"> Total Produzido</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/relatorios-producao-Desempenho">
              <a>
                <span class="page"> Desempenho</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
      <ul class="treeview-menu">
        <li>
          <a>
            <router-link tag="li" class="pageLink" to="/relatorios-oee">
              <a>
                <span class="page"> OEE</span>
              </a>
            </router-link>
          </a>
        </li>
      </ul>
    </li>
    <router-link tag="li" class="pageLink" to="/importar">
     <a>
       <i class="fa fa-upload"></i>
       <span class="page">Importar</span>
     </a>
   </router-link>
   <router-link tag="li" class="pageLink" to="/usuario">
     <a>
       <i class="fa fa-user"></i>
       <span class="page">Usuário</span>
     </a>
   </router-link>
   <router-link tag="li" class="pageLink" to="/logout">
     <a>
       <i class="fa fa-sign-out"></i>
       <span class="page">Sair</span>
     </a>
   </router-link>
 </ul>
</template>
<script>
export default {
  name: 'SidebarMenu'
}
</script>
<style>
/* override default */
.sidebar-menu > li > a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active > a > .fa-angle-left,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
  animation-name: rotate;
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
}

.treeview-title {
  z-index: 1;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?50c06f5c